import React, {Component} from "react";
import BsyIconBtn from "../BsyIconBtn";
import BsyDialog from "../BsyDialog";
import BsySLoading from "../BsySLoading";
import tipAlert from "../../Login/BsyAlertTip/Staticize";

class ReleaseNewVersion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || {},
      appsMap: {},
      isLoading: true,
    }
    this.updateContRef = React.createRef();
    this.docLinkRef = React.createRef();
  }

  componentDidMount() {
    React.axios("/dashboard/standardapp_group/list").then(res => {
      let appsMap = {};
      res.data.items.map(item => {
        item.apps.map(app => {
          appsMap[app._id] = app;
        })
      })
      this.setState({appsMap, isLoading: false})
    })
  }

  openSelectAppPane = () => {
    let appsEl = null;
    const {apps} = this.state.data;
    BsyDialog({
      title: React.language('select.release.app'),
      height: 575,
      width: 800,
      customCls: "bsy-app-export-pane",
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        setTimeout(() => {
          appsEl = new window.FX.AppExportPane({
            renderEl: window.$("<div/>").appendTo(ref.element.current.getElementsByClassName("dialog-body")[0]),
            isStandard: !0,
            value: {
              app: apps
            },
            onStopEdit: function (e) {
              var label = this.onChangeLabel();
            }
          })
        }, 300)
      },
      onOk: () => {
        this.state.data.apps = appsEl.value.app;
        this.setState({data: this.state.data})
      }
    })
  }

  addProjectUpdateCont = ""
  addProjectDocLink = ""

  addChangeProjectUpdateCont = (e) => {
    this.addProjectUpdateCont = e.target.value;
  }

  addChangeProjectDocLink = (e) => {
    this.addProjectDocLink = e.target.value;
  }

  downloadApp = () => {
    const {data} = this.state;
    window.open(`/dashboard/standard_app_down/${data._id}/${data.version}`);
  }

  render() {
    const {data, appsMap, isLoading} = this.state;
    return <div className="ReleaseNewVersion">
      {isLoading && <BsySLoading style={{background: '#ffffff'}}/>}
      <div className="releaseNewVersionBody">
        {/* <div className="item-line version">
          <div className="line-title">{React.language("Latest.version.number")}</div>
          <div className="line-value">
            <div className="version-cont">
              <div className="version-number">{data.version}</div>
              <div className="version-download" onClick={this.downloadApp}>
                <i className="icon-bsy-reportmenu-8"></i>
                <span>{React.language("download.install.package")}</span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="item-line packaged">
          <div className="line-title"><b>*</b>{React.language("Applications.packaged.latest.version")}</div>
          <div className="line-value">
            <div className="apps-cont" onClick={this.openSelectAppPane}>
              {data.apps.length === 0 ? <div className="appsEmptyCont">
                <div className="empty-cont">
                  <i className="icon-bsy-add"></i>
                  <span>{React.language('select.release.standard.app.waterMark')}</span>
                </div>
              </div> : <>
                {
                  data.apps.map(res => {
                    const app = appsMap[res];
                    return app && <div className="app-item" key={res}>
                      <div className="app-icon">
                        <div className={`icon-backgroup color-cover-${app.style.color}`}>
                          <div className={`imgbg-bsy-app imgbg-bsy-app-${app.style.icon}`}></div>
                        </div>
                      </div>
                      <div className="app-name">{app.appname}</div>
                    </div>
                  })
                }
              </>}
            </div>
          </div>
        </div>
        <div className="item-line cont">
          <div className="line-title"><b>*</b><span>{React.language("Update.cont")}</span></div>
          <div className="line-value">
            <div className="update-cont">
              <textarea maxLength={1024} onChange={this.addChangeProjectUpdateCont} ref={this.updateContRef} placeholder={React.language("placeholder.update.cont")}/>
            </div>
          </div>
        </div>
        <div className="item-line link">
          <div className="line-title">{React.language("Doc.link")}</div>
          <div className="line-value">
            <div className="doc-link">
              <input type="text" maxLength={1024} onChange={this.addChangeProjectDocLink} ref={this.docLinkRef} placeholder={React.language("placeholder.doc.link")}/>
            </div>
          </div>
        </div>
      </div>
      <div className="releaseNewVersionFooter">
        <BsyIconBtn
          text={React.language("publish.immediate")}
          click={(event) => {
            if(data.apps.length === 0){
              tipAlert({
                type: "warning",
                msg: React.language('select.release.standard.app.waterMark')
              })
              return
            }
            if(this.addProjectUpdateCont === "" || this.addProjectUpdateCont === " ") {
              tipAlert({
                type: "warning",
                msg: React.language("update.cont.tip")
              })
              return
            }
            this.setState({isLoading: true}, ()=>{
              React.axios("/dashboard/standard_update", {
                "_id": data._id,
                "verUpdate": true,  //更新安装包
                "app_remark": this.addProjectUpdateCont,
                "doc_url": this.addProjectDocLink,
                "appIds": data.apps
              }).then(res => {
                this.props.loadListData();
                data.version = res.data.version;
                this.addProjectUpdateCont = "";
                this.updateContRef.current.value = "";
                this.docLinkRef.current.value = "";
                this.setState({data: data, isLoading: false})
              }).catch(()=>{
                this.setState({isLoading: false})
              })
            })
          }}
          type={"blue"}
          mode={window.mode}
        />
      </div>
    </div>
  }
}

export default ReleaseNewVersion;